var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    stroke: "#1554FF",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0034 9.10011L8.60611 14.5001C8.12926 14.5001 7.67194 14.3104 7.33476 13.9729C6.99757 13.6353 6.80814 13.1775 6.80814 12.7001L6.80814 10.3001L3.21222 10.3001C3.03847 10.3021 2.86637 10.2662 2.70784 10.195C2.54932 10.1237 2.40816 10.0189 2.29414 9.8876C2.18012 9.75633 2.09598 9.60181 2.04753 9.43476C1.99909 9.2677 1.9875 9.0921 2.01357 8.92011L3.04441 3.52015C3.08775 3.234 3.23293 2.97319 3.4532 2.78575C3.67347 2.59831 3.95398 2.49688 4.24305 2.50015L11.0034 2.50015M11.0034 9.10011L11.0034 2.50015M11.0034 9.10011L12.8014 9.10011C13.1193 9.10011 13.4241 8.97368 13.6489 8.74864C13.8737 8.5236 14 8.21838 14 7.90012L14 3.70015C14 3.38189 13.8737 3.07667 13.6489 2.85162C13.4241 2.62658 13.1193 2.50015 12.8014 2.50015L11.0034 2.50015",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisLike);
export default __webpack_public_path__ + "static/media/disLike.e598bdb14117a53828a01bb746daee93.svg";
export { ForwardRef as ReactComponent };